module.exports = __webpack_public_path__ + "static/media/5.49fff4c4.jpg";